import { api } from "./api";
import {
  NotificationLogItem,
  NotificationLogRecipientsQueryParams,
  NotificationLogRecipientsResult,
  NotificationLogsQueryParams,
  NotificationLogsResult,
  NotificationReport,
  NotificationReportQueryParams,
} from "../../models/notification-logs";

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
}

const unwrap = <T>(response: ApiEnvelope<T>): T => response.data;

export const notificationLogsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getNotificationLogs: build.query<NotificationLogsResult, NotificationLogsQueryParams>({
      query: (params) => ({
        url: "/bo/notification-logs",
        params: {
          page: params.page,
          limit: params.limit,
          ...(params.search ? { search: params.search } : {}),
          ...(params.type ? { type: params.type } : {}),
          ...(params.channel ? { channel: params.channel } : {}),
          ...(params.triggerRule ? { trigger_rule: params.triggerRule } : {}),
          ...(params.dateFrom ? { date_from: params.dateFrom } : {}),
          ...(params.dateTo ? { date_to: params.dateTo } : {}),
        },
      }),
      transformResponse: (response: ApiEnvelope<NotificationLogsResult>) => unwrap(response),
      providesTags: ["notificationLogs"],
    }),
    getNotificationReport: build.query<NotificationReport, NotificationReportQueryParams>({
      query: (params) => ({
        url: "/bo/notification-logs/report",
        params: {
          date_from: params.dateFrom,
          date_to: params.dateTo,
          granularity: params.granularity,
          ...(params.type ? { type: params.type } : {}),
          ...(params.triggerRule ? { trigger_rule: params.triggerRule } : {}),
        },
      }),
      transformResponse: (response: ApiEnvelope<NotificationReport>) => unwrap(response),
      providesTags: ["notificationLogs"],
    }),
    getNotificationLog: build.query<NotificationLogItem, string>({
      query: (id) => ({ url: `/bo/notification-logs/${id}` }),
      transformResponse: (response: ApiEnvelope<NotificationLogItem>) => unwrap(response),
      providesTags: ["notificationLogs"],
    }),
    getNotificationLogRecipients: build.query<
      NotificationLogRecipientsResult,
      NotificationLogRecipientsQueryParams
    >({
      query: ({ id, page, limit, status }) => ({
        url: `/bo/notification-logs/${id}/recipients`,
        params: { page, limit, ...(status ? { status } : {}) },
      }),
      transformResponse: (response: ApiEnvelope<NotificationLogRecipientsResult>) =>
        unwrap(response),
      providesTags: ["notificationLogs"],
    }),
  }),
});

export const {
  useGetNotificationLogsQuery,
  useGetNotificationReportQuery,
  useGetNotificationLogQuery,
  useGetNotificationLogRecipientsQuery,
} = notificationLogsApi;
